// eslint-disable-next-line import/namespace
import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";
import { HOST_ENV } from "../../data/constants/urls";

export default function reportWebVitals(onPerfEntry) {
  if (
    HOST_ENV !== "development" &&
    onPerfEntry &&
    onPerfEntry instanceof Function
  ) {
    onCLS(onPerfEntry);
    onFCP(onPerfEntry);
    onINP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
  }
}
